import styled from 'styled-components'

const fullScreenOverwrite = `
.image-gallery.fullscreen-modal .image-gallery-content {
    top:inherit;
    transform:inherit;
    width:100%;
  }
.image-gallery.fullscreen-modal{
  display:flex;
  align-items:center;
}
.image-gallery-fullscreen-button,
.image-gallery-play-button {
    position: fixed; 
    top: 15px;
    margin-right:15px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding:0;

    @media (max-width:991px){
      top: 10px;
      margin-right:10px;
    }
}
`

export const ImageGalleryContainer = styled.div<{ isFullscreen?: boolean }>`
  .image-gallery-image {
    ${(props) => !props.isFullscreen && 'height: 402px;'}
    ${(props) => (props.isFullscreen ? 'object-fit: contain;' : 'object-fit: cover;')}
  }
  .image-gallery-thumbnail {
    border-width: 1px;
    opacity: 0.5;
    transition: opacity 0.2s ease-in-out;

    &.active {
      opacity: 1;
    }
  }

  .image-gallery-thumbnail-image {
    height: 60px;
    object-fit: cover;
  }
  .image-gallery.fullscreen-modal {
    z-index: 10;
  }

  .image-gallery-thumbnails-container {
    ${(props) => !props.isFullscreen && 'text-align: left;'}
  }

  .image-gallery-icon:focus {
    outline: none;
  }

  .image-gallery-index {
    padding: 0 10px;
    font-size: ${(props) => (props.isFullscreen ? '1em' : '0.6em')};
    height: 30px;
    line-height: 30px;
    right: 50%;
    top: 100%;
    transform: translate(50%, -100%);
  }
  .image-gallery-icon {
    transition: none;
  }
  .image-gallery-icon:hover {
    color: #ffffff;

    .image-gallery-svg {
      transform: scale(1.2);
    }
  }

  .image-gallery-left-nav .image-gallery-svg,
  .image-gallery-right-nav .image-gallery-svg {
    height: 60px;
    width: auto;
    margin-top: 15px;
  }

  .image-gallery-left-nav .image-gallery-svg {
    margin-left: ${(props) => (props.isFullscreen ? ' 15px' : '-5px')};
  }

  .image-gallery-right-nav .image-gallery-svg {
    margin-right: ${(props) => (props.isFullscreen ? ' 15px' : '-5px')};
  }

  .image-gallery-fullscreen-button,
  .image-gallery-play-button {
    padding: 8px;
    .image-gallery-svg {
      height: 15px;
      width: auto;
    }
  }

  @media (max-width: 767px) {
    .image-gallery-image {
      ${(props) => !props.isFullscreen && 'height: 250px;'}
    }
  }

  @media (max-width: 991px) {
    .image-gallery-left-nav .image-gallery-svg {
      margin-left: -5px;
    }

    .image-gallery-right-nav .image-gallery-svg {
      margin-right: -5px;
    }
  }

  ${(props) => props.isFullscreen && fullScreenOverwrite}
`
